import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Clock, Calendar, User } from 'lucide-react';
import { getBlogPostById } from '../services/contentService';
import { countries } from '../data/mockData';
import './BlogDetail.css';

function BlogDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBlogPost();
  }, [id]);

  const loadBlogPost = async () => {
    try {
      setLoading(true);
      const response = await getBlogPostById(id);
      if (response.success && response.data) {
        const postData = {
          ...response.data,
          countryId: response.data.country_id,
          readTime: response.data.read_time
        };
        setPost(postData);
      }
    } catch (error) {
      console.error('Error loading blog post:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="blog-detail-loading">
        <p>Lade Blogbeitrag...</p>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="blog-detail-error">
        <h2>Blogbeitrag nicht gefunden</h2>
        <Link to="/" className="btn-primary">
          <ArrowLeft size={20} />
          Zurück zur Startseite
        </Link>
      </div>
    );
  }

  const country = countries.find(c => c.id === post.countryId);

  return (
    <article className="blog-detail">
      <div className="blog-detail-header">
        <Link to="/#blog" className="back-link">
          <ArrowLeft size={20} />
          Zurück zum Blog
        </Link>
        
        {country && (
          <span className="blog-country-tag">{country.name}</span>
        )}
      </div>

      <div className="blog-detail-hero">
        <img 
          src={post.image} 
          alt={post.title}
          className="blog-hero-image"
        />
      </div>

      <div className="blog-detail-container">
        <header className="blog-detail-title-section">
          <h1 className="blog-detail-title">{post.title}</h1>
          
          <div className="blog-detail-meta">
            <span className="meta-item">
              <User size={16} />
              {post.author || 'Thomas & Jasmin'}
            </span>
            <span className="meta-item">
              <Calendar size={16} />
              {new Date(post.date).toLocaleDateString('de-DE', { 
                day: 'numeric', 
                month: 'long', 
                year: 'numeric' 
              })}
            </span>
            <span className="meta-item">
              <Clock size={16} />
              {post.readTime}
            </span>
          </div>

          {post.excerpt && (
            <p className="blog-detail-excerpt">{post.excerpt}</p>
          )}
        </header>

        <div className="blog-detail-content">
          {post.content.split('\n\n').map((paragraph, index) => (
            <p key={index} className="content-paragraph">
              {paragraph}
            </p>
          ))}
        </div>

        {post.tags && post.tags.length > 0 && (
          <div className="blog-detail-tags">
            <h3>Tags</h3>
            <div className="tags-list">
              {post.tags.map((tag, index) => (
                <span key={index} className="tag">{tag}</span>
              ))}
            </div>
          </div>
        )}

        <footer className="blog-detail-footer">
          <Link to="/#blog" className="btn-outline">
            <ArrowLeft size={20} />
            Alle Blogbeiträge ansehen
          </Link>
        </footer>
      </div>
    </article>
  );
}

export default BlogDetail;
